import { GUIDE_EMBED_MESSAGE_TYPES, GUIDE_EMBED_SOURCE } from './config';

export const normalizeGuideNavigationUrl = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    const parsedUrl = new URL(value.trim());
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:'
      ? parsedUrl.href
      : null;
  } catch (error) {
    return null;
  }
};

const readOptionalString = (value) =>
  typeof value === 'string' && value.trim() ? value : undefined;

/**
 * Accetta solo i messaggi che arrivano dal contentWindow del pannello: e' il
 * controllo piu' forte disponibile, come per l'embed delle novita'.
 */
export const parseGuideEmbedMessage = (event, expectedSource) => {
  const data = event && event.data;

  if (
    !event ||
    !expectedSource ||
    event.source !== expectedSource ||
    !data ||
    typeof data !== 'object' ||
    Array.isArray(data) ||
    data.source !== GUIDE_EMBED_SOURCE ||
    GUIDE_EMBED_MESSAGE_TYPES.indexOf(data.type) === -1
  ) {
    return null;
  }

  if (data.type === 'ofc:open_url') {
    const url = readOptionalString(data.url) || readOptionalString(data.href);
    return url ? { type: data.type, url } : null;
  }

  if (data.type === 'ofc:go_back') {
    return {
      type: data.type,
      fallbackUrl: readOptionalString(data.fallbackUrl),
      path: readOptionalString(data.path),
    };
  }

  return { type: data.type };
};
